'use client';

import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { Icon, Switch, Text, Tooltip } from '@stone-payments/jade';
import { MiniLogoStone } from '../../header/miniLogoStone';

export const GlobalWalletSwitch = () => {
  const {
    globalWalletVariant,
    globalWalletVariantPayload,
    saveCardForFutureChecked,
    setSaveCardForFutureChecked,
  } = usePaymentMethod();

  if (globalWalletVariant === 'pending' || !globalWalletVariantPayload) {
    return null;
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSaveCardForFutureChecked(event.target.checked);
    analiticaInstance.events.billingPage.fakedoorToggleClicked(
      event.target.checked
    );
  };

  const handleTooltipInteraction = () => {
    analiticaInstance.events.billingPage.fakedoorTooltipInteracted();
  };

  return (
    <div
      className="flex items-center justify-between gap-jade-200 mt-jade-200 p-jade-200 rounded-jade-medium border border-solid border-jade-border-low bg-jade-background-surface"
      data-testid="global-wallet-switch"
    >
      <div className="flex flex-col gap-jade-50">
        <div className="flex items-center gap-jade-50">
          <Text variant="text-medium" weight="medium">
            {globalWalletVariantPayload.title}
          </Text>
          <Tooltip
            placement="top"
            trigger={
              <span
                data-testid="global-wallet-tooltip-trigger"
                onMouseEnter={handleTooltipInteraction}
                onClick={handleTooltipInteraction}
              >
                <Icon color="medium" size="small" use="circle-info" />
              </span>
            }
            text={globalWalletVariantPayload.tooltip_text}
          />
        </div>
        <div className="flex items-center gap-jade-50">
          <Text variant="text-small" color="medium">
            {globalWalletVariantPayload.description}
          </Text>
          <MiniLogoStone className="h-[11px] w-auto" />
        </div>
      </div>
      <Switch
        id="save-card-for-future"
        name="save-card-for-future"
        checked={Boolean(saveCardForFutureChecked)}
        onChange={handleChange}
      />
    </div>
  );
};
